import React, { createContext, useContext, useState } from 'react';

const UserContext = createContext({
  user: null,
  setUser: () => {},
  clearUser: () => {},
  isLoading: false,
  setIsLoading: () => {}
});

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const clearUser = () => {
    setUser(null);
  };

  return (
    <UserContext.Provider value={{ 
      user, 
      setUser, 
      clearUser, 
      isLoading, 
      setIsLoading 
    }}>
      {children}
    </UserContext.Provider>
  );
}; 